/**
 * @generated SignedSource<<0bc1d6a2dd3a4e1e90b7d287da051f4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UpdatePriceLocation_getLocationQuery$variables = {
  id: string;
};
export type UpdatePriceLocation_getLocationQuery$data = {
  readonly getLocation: {
    readonly applicableTax: number | null;
    readonly flavorPrices: ReadonlyArray<{
      readonly flavor: string;
      readonly isActive: boolean;
      readonly price: number;
    }> | null;
    readonly id: string;
    readonly uuid: string | null;
  };
};
export type UpdatePriceLocation_getLocationQuery = {
  response: UpdatePriceLocation_getLocationQuery$data;
  variables: UpdatePriceLocation_getLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicableTax",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationFlavorPricesObjectType",
        "kind": "LinkedField",
        "name": "flavorPrices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flavor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePriceLocation_getLocationQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePriceLocation_getLocationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "035b89c942990b28ee8322f9d8daa5f0",
    "id": null,
    "metadata": {},
    "name": "UpdatePriceLocation_getLocationQuery",
    "operationKind": "query",
    "text": "query UpdatePriceLocation_getLocationQuery(\n  $id: String!\n) {\n  getLocation(id: $id) {\n    id\n    uuid\n    applicableTax\n    flavorPrices {\n      flavor\n      price\n      isActive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7290489965afb479e095bb74eea424a";

export default node;
